import { CommonSelectInput } from 'components/common/form/select';
import { HittersContext } from 'contexts/hitters.context';
import { HitterDataSource } from 'lib_ts/enums/hitters.enums';
import { useContext } from 'react';

export const SelectHitterDataSource = () => {
  const { loading, filters, setFilters } = useContext(HittersContext);

  return (
    <CommonSelectInput
      id="hitters-data-source"
      name="source"
      placeholder="common.source"
      options={Object.values(HitterDataSource).map((o) => ({
        label: o,
        value: o,
      }))}
      value={filters.source}
      onChange={(v) => {
        const current = filters;

        if (!v) {
          delete current.source;
        } else {
          current.source = v as HitterDataSource;
        }

        setFilters({ ...current });
      }}
      disabled={loading}
      optional
      skipSort
    />
  );
};
